import { Box, CssBaseline, Grid, styled, Paper, Card, CardMedia, CardActions, Button, Modal, Container } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import React from "react";
import { ConnectedProps, connect } from "react-redux";
import { setStateVariable, updateStateVariables } from "../../AppAction";
import "./Holiday.css";
import { DOCUMENT_SETSTATE } from "./HolidayActionType";
import { openPopup } from "../CommonPopup/PopupReducer";

const apiConfig = window as any;

const GridEditTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#82b6e5',
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[2],
        fontSize: 11,
    },
}));


const styleVide = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};


class HolidayPage extends React.Component<Props> {


    async componentDidMount() {
        const { setStateVariable, updateStateVariables } = this.props;
    }


    shouldComponentUpdate() {
        return true;
    }

    handleDrawerToggle = () => {
        console.log("Test");
    }




    startVideo = (index: any) => {
        console.log(index);
        const { setStateVariable, updateStateVariables } = this.props;
        setStateVariable(DOCUMENT_SETSTATE, "startv", true);
        setStateVariable(DOCUMENT_SETSTATE, "indexV", index);

    }

    stopVideo = () => {
        const { setStateVariable, updateStateVariables } = this.props;
        setStateVariable(DOCUMENT_SETSTATE, "startv", false);
    };

    cardVideo = (videoThumbnail: string | undefined, videoUrl: string | undefined, title: string, indexR: any) => {

        const { holidayR } = this.props;
        // const { startv } = this.state;
        return (
            <div>
                {/* Video Card */}
                <Card //sx={{ maxWidth: 345 }}
                >
                    <CardMedia
                        component="img"
                        alt="Video Thumbnail"
                        //height="140"
                        image={videoThumbnail}
                        onClick={() => this.startVideo(indexR)}  // Open Modal on click
                        sx={{ cursor: 'pointer' }}
                    />
                    {/* <CardContent>
                <h2>{title}</h2>
              </CardContent> */}
                    <CardActions>
                        <Button size="small" onClick={() => this.startVideo(indexR)}>Play Video</Button>
                    </CardActions>
                </Card>

                {/* Modal for Video */}
                <Modal
                    open={holidayR.startv}
                    onClose={this.stopVideo}
                    aria-labelledby="modal-video-title"
                    aria-describedby="modal-video-description"
                >
                    <Box sx={styleVide}>
                        <iframe
                            width="100%"
                            height="400"
                            // src={videoUrl}
                            src={process.env.PUBLIC_URL + "/HolidayVideos/MOV_" + holidayR.indexV + ".mp4"}
                            title="Video Player"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        // allowFullScreen
                        ></iframe>
                    </Box>
                </Modal>
            </div>
        );
    }

    cardVideoMain = () => {

        const { holidayR } = this.props;

        // const videos = [
        //     {
        //         title: 'Sample Video 1',
        //         videoThumbnail: process.env.PUBLIC_URL + "/HolidayVideos/MOV_1.jpg", // Replace with your thumbnail
        //         videoUrl: process.env.PUBLIC_URL + "/HolidayVideos/MOV_1.mp4", // Example video URL (YouTube)
        //     },
        //     {
        //         title: 'Sample Video 2',
        //         videoThumbnail: process.env.PUBLIC_URL + "/HolidayVideos/MOV_1.jpg", // Replace with your thumbnail
        //         videoUrl: process.env.PUBLIC_URL + "/HolidayVideos/MOV_1.mp4", // Example video URL (YouTube)
        //     },
        // ];

        const videos = [];

        for (let index = 1; index < holidayR.intVideo; index++) {

            const videoUrlName = "MOV_" + index + ".mp4";
            const videoThumbnailName = "VIMG_" + index + ".jpg";

            const gallObj = {
                "title": "VIMG_" + index,
                "videoThumbnail": process.env.PUBLIC_URL + "/HolidayVideos/VIMG_" + index + ".jpg",
                videoUrl: process.env.PUBLIC_URL + "/HolidayVideos/MOV_" + index + ".mp4",
            }
            videos.push(gallObj);
        }

        // console.log(videos);

        return (
            <div>
                <Grid container spacing={2} className="carvingGridContainerClass">
                    {videos.map((video: any, index: any) => (
                        <Grid item key={index} xs={12} sm={3}>
                            {/* {this.cardVideo(video.videoThumbnail, video.videoUrl, video.title)} */}
                            {this.cardVideo(video.videoThumbnail, process.env.PUBLIC_URL + "/HolidayVideos/MOV_" + index + ".mp4", video.title, index + 1)}
                        </Grid>
                    ))}
                </Grid>

                <Button size="medium" className="cardButton" onClick={this.showMoreVideos}> Show More</Button>

            </div>
        );
    }


    showMoreVideos = () => {
        const { setStateVariable, updateStateVariables } = this.props;
        const { holidayR } = this.props;
        setStateVariable(DOCUMENT_SETSTATE, "intVideo", parseInt(holidayR.intVideo) + 10);
    }

    showMoreImage = () => {
        const { setStateVariable, updateStateVariables } = this.props;
        const { holidayR } = this.props;
        if (parseInt(holidayR.intImage) < apiConfig.HOLIDAY_STOP_COUNTER)
            setStateVariable(DOCUMENT_SETSTATE, "intImage", parseInt(holidayR.intImage) + 10);
    }

    weddingPage = () => {

        const { holidayR, openPopup } = this.props;

        const iceCarvlistOfImg = [];

        console.log(holidayR.intImage);

        for (let index = 1; index < holidayR.intImage; index++) {

            const gallObj = {
                "name": "DSC_" + index + ".jpg"
            }
            iceCarvlistOfImg.push(gallObj);
        }


        // const container = window !== undefined ? () => document.body : undefined;
        return (
            <div >

                <fieldset>
                    <legend className="legendClass">Holiday Images</legend>
                    <Grid container spacing={2} className="carvingGridContainerClass">
                        {
                            iceCarvlistOfImg.map((abc: any, k: any) => {
                                return (
                                    <Grid key={k} xs={12} sm={3} item>
                                        <Paper key={k} className="imgPaperClass">
                                            {/* <img src={abc.name} className='carouselImg'></img> */}

                                            <img src={process.env.PUBLIC_URL +
                                                "/HolidayImages/" + abc.name} className='galleryImgClass' style={{ cursor: "pointer" }}
                                                onClick={() => openPopup(process.env.PUBLIC_URL + "/HolidayImages/" + abc.name)}
                                            />
                                        </Paper>
                                    </Grid>)
                            })}
                    </Grid>

                    <Button size="medium" className="cardButton" onClick={this.showMoreImage}> Show More</Button>

                </fieldset>

                <fieldset>
                    <legend className="legendClass">Holiday Videos</legend>
                    {this.cardVideoMain()}

                </fieldset>
            </div>
        );
    }


    render() {

        return (
            <div className="fullWidth">
                <Grid container>
                    <Grid item xs={12} className="galleryHeader" >
                        Holiday Images
                    </Grid>
                </Grid>
                <div>
                    <this.weddingPage />
                </div>
            </div >
        )
    }
}

const mapStateToProps = (state: any) => {
    const app = state.app;
    const holidayR = state.holidayR;
    return {
        app: app,
        holidayR: holidayR,
    };
};

const mapDispatchToProps = {
    setStateVariable,
    updateStateVariables,
    openPopup
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux;

export default connector(HolidayPage);